import axios from "axios";
import { GetAllGGNotificationFiltersDTO, GetAllGGNotificationDTO, GGNotificationDTO, GGNotificationUpdateDTO } from "./dto";
import { GGNotificationService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class GGNotificationServiceImpl implements GGNotificationService {

    public CreateGGNotification(data: GGNotificationUpdateDTO): Promise<void> {
        return axios.post("/api/gg-notification",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotification(filters: GetAllGGNotificationFiltersDTO): Promise<GetAllGGNotificationDTO> {
        return axios.get("/api/gg-notification", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                customerId: filters.customerId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationById(id: string): Promise<GGNotificationDTO> {
        return axios.get("/api/gg-notification/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UpdateGGNotification(data: GGNotificationUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/gg-notification/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}